import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-veiculo-pj',
  templateUrl: './veiculo-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./veiculo-pj.component.css']
})
export class VeiculoPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.veiculo===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.veiculo===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
